// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-answer.responsive {\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.iframe-answer .iframe-answer-header.responsive {\n  flex-basis: auto;\n}\n.iframe-answer .iframe-answer-content.responsive {\n  flex: 1;\n}\n.iframe-answer .iframe-answer-content.responsive iframe {\n  height: 100%;\n  width: 100%;\n}\n.iframe-answer a {\n  color: #479492;\n  text-decoration: none;\n  cursor: pointer;\n}\n.iframe-answer a:hover {\n  color: #da5936;\n}\n", ""]);
// Exports
module.exports = exports;
